import { useMemo, useSyncExternalStore } from "react";

import { formatSearchSynopsis } from "../util/search/searchSynopsis";

const hasSearchInput = search =>
  search != null &&
  typeof search === "object" &&
  !Array.isArray(search) &&
  Object.keys(search).length > 0;

const NO_TERMS = [];

// The results page's query returns the synopsis terms alongside its rows and
// keeps them in the module's navigation snapshot, so the list header and the
// primary nav (including on record pages) share them without another request.
const useSearchSynopsis = navigationStore => {
  const terms = useSyncExternalStore(
    navigationStore.subscribe,
    () => navigationStore.get()?.searchSynopsisTerms || NO_TERMS,
  );
  const synopsis = useMemo(() => formatSearchSynopsis(terms), [terms]);
  return { synopsis, terms };
};

export { hasSearchInput, useSearchSynopsis };
